export const KM220_LOADER_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/static/km220-loader-logo.svg`;
